import { Routes } from '@angular/router';
import { LayoutComponent } from '@layout/layout.component';
import { ERoute } from '@core/routes';

export const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: ERoute.Home,
      },
      {
        path: ERoute.Home,
        loadChildren: () => import('@pages/home/home.routes'),
      },
      {
        path: ERoute.Roulette,
        loadChildren: () => import('@pages/roulette/roulette.routes'),
      },
      {
        path: ERoute.MiniGames,
        loadChildren: () => import('@pages/mini-games/mini-games.routes'),
      },
      {
        path: ERoute.Profile,
        loadChildren: () => import('@pages/profile/profile.routes'),
      },
      {
        path: 'jellyfish',
        loadChildren: () => import('@pages/jellyfish/jellyfish.routes'),
      },
      {
        path: 'leaders',
        loadChildren: () => import('@pages/leaders/leaders.routes'),
      },
    ],
  },
  {
    path: '**',
    redirectTo: ERoute.Home,
  },
];
